export default __webpack_public_path__ + "static/char-s-31-zh-Hans-877968bbe0bdca86168a9a33774eddb1.png";